/* path: src/Utils/shifts.js */
// Shift definitions
export const shifts = {
  breakfast: { start: '07:00', end: '11:00' },
  lunch: { start: '11:00', end: '16:00' },
  dinner: { start: '16:00', end: '23:00' },
};

// Helpers to map a time string ("HH:mm") to a shift
export const parseTimeToMinutes = (hhmm) => {
  const match = /^(\d{1,2}):(\d{2})$/.exec(hhmm);
  if (!match) return null;
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  return hours * 60 + minutes;
};

export const inRange = (timeMin, startHHMM, endHHMM) => {
  const start = parseTimeToMinutes(startHHMM);
  const end = parseTimeToMinutes(endHHMM);
  if (start === null || end === null || timeMin === null) return false;
  // inclusive start, exclusive end
  return timeMin >= start && timeMin < end;
};

export const getShiftForTime = (timeHHMM) => {
  const mins = parseTimeToMinutes(timeHHMM);
  if (mins === null) return null;
  if (inRange(mins, shifts.breakfast.start, shifts.breakfast.end)) return 'breakfast';
  if (inRange(mins, shifts.lunch.start, shifts.lunch.end)) return 'lunch';
  if (inRange(mins, shifts.dinner.start, shifts.dinner.end)) return 'dinner';
  return null;
};
